module.exports = __webpack_public_path__ + "static/media/mendeley.61c4875a.svg";